import React, { FunctionComponent, useContext } from 'react';
import styles from './styles.module.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { FollowButtons } from 'features/chat/components/FollowButtons';
import { SupportButton } from 'components/Support/SupportButton';
import { ChannelSocialLinks } from 'features/channel/components/ChannelSocialLinks';
import { useCurrentUser } from 'features/current-user/hooks';
import classNames from 'classnames';
import { UserAgentContext } from 'features/user-agent/userAgent';

export const ChannelInfo: FunctionComponent = () => {
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );
  const currentUser = useCurrentUser();

  const { isNativeAppWebview, isCreatorAppWebview } =
    useContext(UserAgentContext);

  if (!channel || isCreatorAppWebview) {
    return null;
  }

  return (
    <div className={styles['channel-info']}>
      {!isNativeAppWebview && (
        <h1 className={classNames(styles['channel-info__title'], 'truncate')}>
          {channel.username}
        </h1>
      )}
      <div className={styles['channel-info__links']}>
        <ChannelSocialLinks iconList={true} />
        <SupportButton />
        <FollowButtons
          selectedProfileId={channel.ownerId}
          followedIds={(currentUser && currentUser.followedUserIds) || []}
        />
      </div>
    </div>
  );
};
